import { USDV_MINT_ADDRESS } from "@solomon-apps/config/network";
import {
    TOKEN_2022_PROGRAM_ID_STRING,
    TOKEN_PROGRAM_ID_STRING,
    WELL_KNOWN_TOKENS_STRINGS
} from "@solomon-labs/constants";

/** The mint used by current USDv product flows. */
export const CURRENT_USDV_MINT_ADDRESS = USDV_MINT_ADDRESS;

/** The retired classic-SPL USDv mint, retained only to support wallet migration. */
export const LEGACY_USDV_MINT_ADDRESS = WELL_KNOWN_TOKENS_STRINGS.USDv;

/** Compatibility alias for product flows that consume the current USDv mint. */
export const USDV_MINT = CURRENT_USDV_MINT_ADDRESS;

/** Compatibility alias for migration-only flows that consume the retired USDv mint. */
export const LEGACY_USDV_MINT = LEGACY_USDV_MINT_ADDRESS;

export const CURRENT_USDV_DECIMALS = 6;
export const LEGACY_USDV_DECIMALS = 9;

/** Decimal precision for current USDv product flows. */
export const USDV_DECIMALS = CURRENT_USDV_DECIMALS;
export const CURRENT_USDV_TOKEN_PROGRAM_ID = TOKEN_2022_PROGRAM_ID_STRING;
export const LEGACY_USDV_TOKEN_PROGRAM_ID = TOKEN_PROGRAM_ID_STRING;

export const USDV_TOKEN_PROGRAM_IDS = [LEGACY_USDV_TOKEN_PROGRAM_ID, CURRENT_USDV_TOKEN_PROGRAM_ID] as const;

export function isCurrentUsdvMint(mint: string): boolean {
    return mint === CURRENT_USDV_MINT_ADDRESS;
}

export function isLegacyUsdvMint(mint: string): boolean {
    return mint === LEGACY_USDV_MINT_ADDRESS;
}
